export default __webpack_public_path__ + "static/media/3.04a86c93.png";